import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { RatingStarComponent } from '../../icons/rating-star/rating-star.component';

@Component({
    selector: 'lib-star-rating-selector',
    standalone: true,
    imports: [CommonModule, RatingStarComponent],
    templateUrl: './star-rating-selector.component.html',
    styleUrl: './star-rating-selector.component.css'
})
export class StarRatingSelectorComponent {
    /* eslint-disable */
    @Input() rating: number = 0;
    @Input() allowUnset: boolean = false;
    @Input() displayRatingAmountLabel: boolean = false;
    @Input() ratingAmountLabel: string = '';

    @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

    onClick(rating: number): void {
        const unset = this.allowUnset && rating === this.rating;

        this.rating = unset ? 0 : rating;

        this.ratingClick.emit({
            rating: unset ? 0 : rating
        });
    }
}
